
import * as Sizes from "./sizes"


const Styles = {
    devices: Sizes.device,
    deviceSizes: Sizes.size,
}
export { Styles }



